import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { BsGithub } from "react-icons/bs";
import { BsFacebook } from "react-icons/bs";
function HeaderSocials() {
  return (
    <div className="header__socials">
      <a
        href="https://www.linkedin.com/in/imane-boulouane-0ba280199/"
        target="_blank"
      >
        <BsLinkedin />
      </a>
      <a href="https://github.com/Imanebln" target="_blank">
        <BsGithub />
      </a>
      <a href="https://www.facebook.com/imane.bln.5/" target="_blank">
        <BsFacebook />
      </a>
    </div>
  );
}

export default HeaderSocials;
